import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { useRootStore } from 'store/rootStore';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { zywaveUserRights, employerRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';

export function getGroupProfileHubDestination(groupId: string, userRoles: SupportedUserRoles[]): string {
  if (employerRights(userRoles)) {
    return `/employee?groupId=${groupId}`;
  }
  if (zywaveUserRights(userRoles)) {
    return `/zywave-group/${groupId}`;
  }
  return `/group/${groupId}`;
}

/**
 * Entry route for /group-hub/:groupId. Sends users to the group profile experience
 * that matches their role (employer, Zywave, or broker legacy group page).
 */
const GroupHubPage: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();
  const {
    userStore: { userRoles },
  } = useRootStore();
  const convertedRoles = userRoles.map((role) => toJS(role)).slice();

  return <Redirect to={getGroupProfileHubDestination(groupId, convertedRoles)} />;
});

export default GroupHubPage;
